import React from 'react';

import gnj from '../assets/images/gnj/gnj.png';

const GoodnightJournal = ({ isVisible }) => {
    const animation = isVisible ? 'animated-1' : '';
    const animation1 = isVisible ? 'animated-3' : '';
    const animation2 = isVisible ? 'animated-4' : '';

    return (
      <div className="portfolio container reverse">
        <div className={"showcase_desc no-opacity " + animation1}>
          <h2>Goodnight Journal</h2>
          <p>I founded and developed a journal app that has garnered over 100,000 users and continues to grow. Built using React, Redux, Stripe on AWS Amplify.</p>
          <p className="my-role">My Role: Founder, Design & Development</p>
          <p className="year-completed">Year of Completion: 2020</p>
          <p><a className="cta-btn" href="https://www.goodnightjournal.com/" target="_blank" rel="noopener noreferrer" id="goodnight_journal_cta">Goodnight Journal</a></p>
          
        </div>
        <div className="showcase_wrap">
          <div className="project">
            <img className={"no-opacity " + animation} src={gnj} alt="Goodnight Journal" />
          </div>
          <div className="project_bg">
            <svg viewBox="0 0 1900 1900" className={"svg_bg no-opacity " + animation2} xmlns="http://www.w3.org/2000/svg">
              <path d="M1801.88593,1251.04708 C1602.33141,1576.38336 1174.20491,1782.48304 793.648009,1726.99466 C452.732457,1671.50629 16.6776809,1528.82189 24.6059495,1108.69562 C24.6059495,1037.35342 0.821143569,966.011222 0.821143569,902.595935 C-15.0353937,522.104214 199.02786,78.1972068 619.226099,14.78192 C1031.49607,-48.6333668 1443.76604,94.0510285 1713.32717,403.200552 C1895.67735,609.300234 1903.60562,926.376668 1827.90651,1180.57684 C1820.44601,1204.22282 1811.97069,1227.82916 1801.88593,1251.04708" fill="#e14444">
              </path>
            </svg>
          </div>
        </div>
      </div>
    )
}

export default GoodnightJournal



// WEBPACK FOOTER //
// ./src/components/GoodnightJournal.js